import { CaretDownIcon, CaretSortIcon, CaretUpIcon } from '@radix-ui/react-icons';
import { Button } from '../ui/button';

const DatatableSortButton = ({ column, children }) => {
    // Determine sorting direction
    const isSorted = column.getIsSorted();
    const SortIcon =
        isSorted === "asc" ? CaretUpIcon : isSorted === "desc" ? CaretDownIcon : CaretSortIcon;

    return (
        <Button
            variant="ghost"
            onClick={column.getToggleSortingHandler()} // Use built-in handler
        >
            {children}
            <SortIcon className="ml-2 h-4 w-4" />
        </Button>
    );
};

export default DatatableSortButton;
